import React from 'react';

const OvercommitWarningModule = ({ fleetCounts }) => {
  const internalFleet = fleetCounts.internalFleet;
  const overCommitted = internalFleet != null && fleetCounts.sellableFleet != null
    ? (internalFleet + fleetCounts.sellableFleet) > fleetCounts.totalDrones
    : false;

  if (!overCommitted) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2.5 bg-orange-500/10 border border-orange-500/20 rounded-md">
      <svg className="w-4 h-4 text-orange-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
      </svg>
      <span className="text-xs text-orange-400">
        Internal ({internalFleet}) + Sellable ({fleetCounts.sellableFleet}) = {internalFleet + fleetCounts.sellableFleet} exceeds Total Fleet ({fleetCounts.totalDrones}) by {internalFleet + fleetCounts.sellableFleet - fleetCounts.totalDrones}
      </span>
    </div>
  );
};

export default OvercommitWarningModule;
